import _ from "lodash";

export const TYPE_YES = 'yes';
export const TYPE_MAYBE = 'maybe';
export const TYPE_NO = 'no';

export const START_IMMEDIATELY = 'immediately';
export const START_POST_ORIENTATION = 'post-orientation';

export const DEGREE_ALL = 'all';
export const DEGREE_CUSTOM = 'custom';

export const EXTRA_DEGREE_CUSTOM_BASIS_WEEK = 'week';
export const EXTRA_DEGREE_CUSTOM_BASIS_MONTH = 'month';

const TYPE_LABELS = {
	[TYPE_YES]: 'ja sicher',
	[TYPE_MAYBE]: 'eventuell (nach einiger Zusammenarbeit noch zu vereinbaren)',
	[TYPE_NO]: 'nein, nicht für diese Tätigkeit',
};

const START_LABELS = {
	[START_IMMEDIATELY]: 'sofort ab Dienstbeginn',
	[START_POST_ORIENTATION]: 'nach angemessener Einarbeitungszeit',
};

const DEGREE_LABELS = {
	[DEGREE_ALL]: 'alle Arbeitstage/immer',
	[DEGREE_CUSTOM]: 'bestimmte Tagesanzahl',
};

const MANY_DAYS_INFO = 'Soweit es sich um einen Job mit mehr als 5 Arbeitstagen handelt.';

const DAYS_OPTIONS = [
	{value: 0.5, text: 'bis zu 0,5 Tage pro Woche'},
	{value: 1, text: 'bis zu 1 Tag pro Woche'},
	{value: 2, text: 'bis zu 2 Tage pro Woche'},
	{value: 3, text: 'bis zu 3 Tage pro Woche'},
	{value: 4, text: 'bis zu 4 Tage pro Woche'},
	{value: 5, text: 'bis zu 5 Tage pro Woche'},
	{value: 6, text: 'bis zu 6 Tage pro Woche', info: MANY_DAYS_INFO},
	{value: 7, text: 'bis zu 7 Tage pro Woche', info: MANY_DAYS_INFO},
];

export function getTypeLabel (key)
{
	return TYPE_LABELS[key];
}

export function getStartLabel (key)
{
	return START_LABELS[key];
}

export function getDegreeLabel (key)
{
	return DEGREE_LABELS[key];
}

export function getDegreeDaysLabel (key)
{
	return _.find(DAYS_OPTIONS, option => option.value === key).text;
}

export function getDaysOptions ()
{
	return DAYS_OPTIONS;
}
